import { useState } from "react";
import { Plus, X } from "lucide-react";

export const SERVICES = ["Tuns", "Vopsit", "Decolorare / balayage", "Tratamente păr", "Coafat", "Keratină / botox păr", "Extensii", "Bărbierit / barber",
  "Manichiură", "Pedichiură", "Cosmetică", "Machiaj", "Gene / sprâncene", "Epilare", "Masaj"];
export const DAYS = [["", "—"], ["luni", "Luni"], ["marți", "Marți"], ["miercuri", "Miercuri"], ["joi", "Joi"], ["vineri", "Vineri"], ["sâmbătă", "Sâmbătă"]];
export const LABELS = ["Nou", "Activ", "VIP", "Inactiv"];

export const F = ({ label, k, v, set, type = "text", ph = "", wide = false }) => (
  <label className={`st-field bfc-f ${wide ? "is-wide" : ""}`}>
    <span className="st-label">{label}</span>
    {type === "area"
      ? <textarea value={v[k] ?? ""} onChange={(e) => set(k, e.target.value)} placeholder={ph} rows={4} data-testid={`bfc-${k}`} />
      : <input type={type} value={v[k] ?? ""} onChange={(e) => set(k, type === "number" ? e.target.value.replace(/[^\d.]/g, "") : e.target.value)} placeholder={ph} inputMode={type === "number" ? "decimal" : undefined} data-testid={`bfc-${k}`} />}
  </label>
);

export const YesNo = ({ label, k, v, set, yes = "Da", no = "Nu" }) => (
  <div className="st-field bfc-f">
    <span className="st-label">{label}</span>
    <div className="bfc-seg">
      <button type="button" className={v[k] ? "is-on" : ""} onClick={() => set(k, true)} data-testid={`bfc-${k}-yes`}>{yes}</button>
      <button type="button" className={!v[k] ? "is-on" : ""} onClick={() => set(k, false)} data-testid={`bfc-${k}-no`}>{no}</button>
    </div>
  </div>
);

export const Services = ({ v, set }) => {
  const [x, setX] = useState("");
  const list = v.services || [];
  const toggle = (s) => set("services", list.includes(s) ? list.filter((y) => y !== s) : [...list, s]);
  const add = () => { const t = x.trim(); if (t && !list.includes(t)) set("services", [...list, t]); setX(""); };
  return (
    <div className="st-field bfc-f is-wide">
      <span className="st-label">Servicii practicate în salon</span>
      <div className="bf-picker-list">
        {[...SERVICES, ...list.filter((s) => !SERVICES.includes(s))].map((s) => (
          <button key={s} type="button" className={`bf-picker-chip ${list.includes(s) ? "is-on" : ""}`} onClick={() => toggle(s)} aria-pressed={list.includes(s)} data-testid={`bfc-svc-${s.replace(/\W+/g, "-")}`}>{s}{list.includes(s) && !SERVICES.includes(s) && <X size={12} />}</button>
        ))}
      </div>
      <div className="bfc-add">
        <input value={x} onChange={(e) => setX(e.target.value)} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())} placeholder="Alt serviciu" data-testid="bfc-svc-new" />
        <button type="button" className="st-btn st-btn--ghost" onClick={add} disabled={!x.trim()} data-testid="bfc-svc-add"><Plus size={14} /> Adaugă</button>
      </div>
    </div>
  );
};
